import React, { useEffect } from 'react';

export default function ConnectButton() {
  // Store connection state in localStorage to persist across sessions
  useEffect(() => {
    // Setup event listener for connection status
    const handleConnectionSuccess = () => {
      // Save connection status to localStorage
      localStorage.setItem('wallet_connected', 'true');
    };

    // Add event listener to the appkit-button element
    const appkitButton = document.querySelector('appkit-button');
    if (appkitButton) {
      appkitButton.addEventListener('connectionSuccess', handleConnectionSuccess);
    }

    return () => {
      // Clean up event listener
      if (appkitButton) {
        appkitButton.removeEventListener('connectionSuccess', handleConnectionSuccess);
      }
    };
  }, []);

  return (
    /* @ts-expect-error Temporary fix for React 19 */
    <appkit-button
      style={{
        '--appkit-button-background': 'linear-gradient(to right, #8B5CF6, #9333EA)',
        '--appkit-button-hover-background': 'linear-gradient(to right, #7C3AED, #7E22CE)',
        '--appkit-button-text-color': '#FFFFFF',
        '--appkit-button-border-radius': '0.75rem',
        '--appkit-button-padding': '0.75rem 1.5rem',
        '--appkit-button-font-size': '0.925rem',
        '--appkit-button-font-weight': '600',
        '--appkit-button-line-height': '1.25rem',
        '--appkit-button-box-shadow': '0 0 15px rgba(139, 92, 246, 0.3)',
        '--appkit-button-connected-background': 'linear-gradient(to right, #8B5CF6, #9333EA)',
        '--appkit-button-connected-hover-background': 'linear-gradient(to right, #7C3AED, #7E22CE)',
        '--appkit-button-connected-text-color': '#FFFFFF',
        '--appkit-button-connected-box-shadow': '0 0 15px rgba(139, 92, 246, 0.3)',
        '--appkit-button-border': '1px solid rgba(139, 92, 246, 0.5)',
        '--appkit-dropdown-background': '#1A1A1A',
        '--appkit-dropdown-border': '1px solid rgba(139, 92, 246, 0.3)',
        '--appkit-dropdown-text-color': 'white',
        '--appkit-dropdown-hover-background': 'rgba(139, 92, 246, 0.1)',
        '--appkit-dropdown-box-shadow': '0 4px 20px rgba(0, 0, 0, 0.3), 0 0 10px rgba(139, 92, 246, 0.2)'
      }}
      className="w-full transition-all duration-300 transform hover:scale-102"
      persistConnection="true"
      cacheSignatures="true"
      autoConnect="true"
    />
  );
}
